import { Component, ViewEncapsulation } from "@angular/core";
import { TrackJS } from "trackjs";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "../../store/state/app.state";
import {
  SetMenuOption,
  SetGlobalSettings,
  SetNotificationSettings,
} from "../../store/actions/global-header.actions";
import { GlobalHeader } from "src/app/store/models/global-header.model";
import { GlobalHeaderDataService } from "../global-header-data.service";
import { environment } from "../../../environments/environment";
import { AppService } from "src/app/app.service";
import { SetIndustryMengMenuVisibility } from "src/app/store/actions/sector-industry.actions";
import { setRumUserDetails } from "src/app/datadog-rum";
import {
  VAIconRegistryService,
  chevronDown,
  chevronUp,
  chevronRight,
  close,
  externalLink,
} from "@va/core-library/icons";
@Component({
  selector: "app-global-menu",
  templateUrl: "./global-menu.component.html",
  styleUrls: ["./global-menu.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class GlobalMenuComponent {
  apiUrl: string = window.apiUrl;
  legacyUrl = `${window.caUrl}/app`;
  legacyDomain: string = window.caUrl;
  menuOption = [];
  isFreemiumUser = false;
  allowDispatchEngineAccess = false;
  showMenu = false;
  globalHeader: GlobalHeader;
  pageName = "";
  modelManagementLink = "";
  oneAccessLink = "";
  visible: boolean;
  showReportCenter = environment.showReportCenter;
  watchlistData = [];
  isSellside = false;
  isModelsOnlyUser = false;
  modelsOptions = [];
  coverageOptions = [];
  isAssociateCoverageVisible = false;
  isAnalystCoverageVisible = false;
  associateCoverageOptions = [];
  analystCoverageOptions = [];
  globalMenuData;
  globalMenuDataLoading = false;
  expandIndustryAnalysisMegamenu = false;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private dataService: GlobalHeaderDataService,
    private router: Router,
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([
      chevronDown,
      chevronUp,
      chevronRight,
      close,
      externalLink,
    ]);
  }
  ngOnInit() {
    this.store.select("globalHeader").subscribe((data: GlobalHeader) => {
      this.globalHeader = data;
    });
    this.store
      .select(stateGetter("globalSubheader", "pageName"))
      .subscribe((pageName: string) => {
        this.pageName = pageName;
      });
    this.store
      .select(stateGetter("globalHeader", "ssoSettings"))
      .subscribe((data) => {
        if (data.modelManagementLink === false) {
          return;
        }
        this.modelManagementLink = data.modelManagementLink;
        this.oneAccessLink = data.oneAccessLink;
        this.bindMenuData();
      });
    this.router.events.subscribe(() => {
      this.onMenuVisibleChange(false);
    });
  }

  loadUserData() {
    this.globalMenuDataLoading = true;

    this.dataService.getGlobalMenuData().subscribe((data: any) => {
      if (data.status === "success") {
        let watchlists = {},
          compTables = {},
          charts = {};

        Object.keys(data).forEach((key) => {
          if (key === "watchlist") {
            const obj = {
              header: "My Watchlists",
              list: data[key].map((item) => {
                return { ...item, url: `watchlist/${item.id}` };
              }),
              moreLink: "watchlist",
              noListMsg: "You haven't created any watchlists yet.",
              moreMsg: "More watchlists",
              getStartedMsg: "Get started with watchlists",
            };
            watchlists = obj;
          } else if (key === "comp_tables") {
            const obj = {
              header: "My Comp Tables",
              list: data[key].map((item) => {
                return { ...item, url: `comptables/user/${item.id}` };
              }),
              moreLink: "comptables/user",
              moreMsg: "More comp tables",
              noListMsg: "You haven't created any comp tables yet.",
              getStartedMsg: "Get started with comp tables",
            };
            compTables = obj;
          } else if (key === "charts") {
            const obj = {
              header: "My Charts",
              list: data[key].map((item) => {
                return { ...item, url: `charts/${item.id}` };
              }),
              moreLink: "charts",
              moreMsg: "More charts",
              noListMsg: "You haven't created any custom charts yet.",
              getStartedMsg: "Get started with charts",
            };
            charts = obj;
          }
        });
        this.globalMenuData = [{ ...watchlists }];
        if (!this.isModelsOnlyUser) {
          this.globalMenuData.push(compTables, charts);
        }
      }
      this.globalMenuDataLoading = false;
    });
  }

  onClickdataFeature(menu, submenu) {
    if (menu === "Models") {
      this.appService.logUserAction(
        {},
        "",
        "",
        `DE_${submenu.toUpperCase()}_OPTION`,
        { message: `Model ${submenu} Option Clicked from Menu` },
        "",
        this.pageName.toUpperCase(),
      );
    }
  }

  onMenuVisibleChange(visible) {
    this.visible = visible;
    if (visible && !this.isSellside) {
      this.loadUserData();
    }
  }

  toggleMenu(flag) {
    this[flag] = !this[flag];
  }
  bindMenuData() {
    this.http.get(`${this.apiUrl}/api/get_user_default_data?data=1`).subscribe(
      (mexData: any) => {
        this.expandIndustryAnalysisMegamenu =
          mexData.expandIndustryAnalysisMegamenu;
        this.isSellside = mexData.is_sellside;
        this.isModelsOnlyUser = mexData.user_type === "MODELS_ONLY_INBOX";
        this.modelsOptions = [];
        this.coverageOptions = [];
        this.menuOption = [
          {
            name: "Companies",
            link: `/reporting/allcompany`,
            isRouterLink: true,
          },
        ];
        if (mexData.is_sellside !== true) {
          this.menuOption.push({
            name: "Brokers",
            link: `/reporting/allbrokers`,
            isRouterLink: true,
          });
        }
        this.menuOption.push({
          name: "Sectors & Industries",
          link: `/sectors_industries`,
          isRouterLink: true,
        });
        if (mexData.showComparativeAnalysis) {
          this.menuOption.push({
            name: "Comparative Analysis",
            functionOnClick: () => {
              this.dataService.getUserCompId().subscribe((res) => {
                if (res && res.data) {
                  if (
                    res.data["comp_type"] &&
                    res.data["comp_type"] === "user_comp"
                  ) {
                    this.router
                      .navigate([
                        `/comparative-analysis/user/${res.data["tab_id"]}`,
                      ])
                      .then(() => {
                        this.appService.updateLeftPanelSource.next({
                          currentComparativeData: null,
                        });
                      });
                  } else {
                    const params = {
                      comp_type: "industry",
                      id: res.data["tab_id"],
                      sub_id: -1,
                    };
                    this.router.navigate(["/comparative-analysis/current"], {
                      queryParams: params,
                    });
                  }
                }
              });
            },
          });
        }
        if (mexData.is_comps_permitted) {
          this.menuOption.push({
            name: "Peer Analysis",
            link: `/comptables/user`,
            isRouterLink: true,
          });
        }
        if (mexData.is_charts_page_permitted) {
          this.menuOption.push({
            name: "Charts",
            link: `/charts`,
            isRouterLink: true,
          });
        }
        if (mexData.is_industry_metrics_permitted) {
          this.menuOption.push({
            name: "Industry Analysis",
            link: `/industry/${mexData.default_industry_id}/kpis`,
            functionOnClick: (menu) => {
              this.store.dispatch(
                new SetIndustryMengMenuVisibility({
                  isIndustryMegaMenuVisible:
                    this.expandIndustryAnalysisMegamenu,
                }),
              );
              this.expandIndustryAnalysisMegamenu = false;
              this.router.navigateByUrl(menu.link);
            },
          });
        }

        if (mexData.sell_side_broker_shortname !== undefined) {
          this.coverageOptions.push({
            name: `${mexData.sell_side_broker_shortname} Coverage`,
            link: `/reporting/broker/${mexData.sell_side_broker_shortname}`,
            isRouterLink: true,
          });
        }

        if (mexData.Is_Analyst === true) {
          this.coverageOptions.push({
            name: "My Coverage",
            link: `/reporting/analyst/${mexData.Analyst_Id}`,
            isRouterLink: true,
          });
        } else if (mexData.Is_Admin === true && mexData.Is_Analyst === false) {
          const analystCoverageOptions = [];
          const coverageMenu = {
            name: "Analyst Coverage",
            visibilityFlag: "isAnalystCoverageVisible",
            hasSubMenu: mexData.analyst_list.length,
          };
          if (mexData.analyst_list.length) {
            for (let i = 0; i < mexData.analyst_list.length; i++) {
              analystCoverageOptions.push({
                name: mexData.analyst_list[i].analyst_name,
                link: `/reporting/analyst/${mexData.analyst_list[i].analyst_id}`,
                isRouterLink: true,
              });
            }
          }
          this.analystCoverageOptions = [...analystCoverageOptions];
          this.coverageOptions.push(coverageMenu);
        } else if (
          mexData.Is_Associate === true ||
          mexData.Is_Associate_Analyst === true
        ) {
          const associateCoverageOptions = [];
          const coverageMenu = {
            name: "My Coverage",
            visibilityFlag: "isAssociateCoverageVisible",
            hasSubMenu: true, // true, because it will have My Dashboard option
          };
          if (mexData.Is_Associate_Analyst === true) {
            associateCoverageOptions.push({
              name: "My Dashboard",
              link: `/reporting/analyst/${mexData.Analyst_Id}`,
              isRouterLink: true,
            });
          }
          if (mexData.analyst_list.length) {
            for (let i = 0; i < mexData.analyst_list.length; i++) {
              associateCoverageOptions.push({
                name: mexData.analyst_list[i].analyst_name,
                link: `/reporting/analyst/${mexData.analyst_list[i].analyst_id}`,
                isRouterLink: true,
              });
            }
          }
          this.associateCoverageOptions = [...associateCoverageOptions];
          this.coverageOptions.push(coverageMenu);
        }
        if (!mexData.sell_side_broker_shortname) {
          this.menuOption.push({
            name: "Models",
            link: `/reporting/models`,
            isRouterLink: true,
          });
        }

        if (
          mexData.sell_side_broker_shortname !== undefined &&
          mexData.allow_dispatch_engine_access === true
        ) {
          if (mexData.library_access) {
            this.modelsOptions.push({
              name: "Library",
              isRouterLink: false,
              link: `${this.modelManagementLink}/app/models/modellibrary`,
            });
          }
          if (mexData.distributor_access) {
            this.modelsOptions.push({
              name: "Distributor",
              isRouterLink: false,
              link: `${this.modelManagementLink}/app/models/modeldistributor`,
            });
          }
          if (mexData.upload_access) {
            this.modelsOptions.push({
              name: "Upload",
              isRouterLink: false,
              link: `${this.modelManagementLink}/app/models/modelupload`,
            });
          }
          if (mexData.status_access) {
            this.modelsOptions.push({
              name: "Status",
              isRouterLink: false,
              link: `${this.modelManagementLink}/app/models/modelstatus`,
            });
          }
          if (mexData.orderhistory_access) {
            this.modelsOptions.push({
              name: "History",
              isRouterLink: false,
              link: `${this.modelManagementLink}/app/models/orderhistory`,
            });
          }
        }
        // if (
        //   mexData.sell_side_broker_shortname !== undefined &&
        //   mexData.allow_sb_access === true
        // ) {
        //   const sbObj = {
        //     name: "Service Bureau",
        //     values: [
        //       {
        //         name: "Request History",
        //         link: `${this.modelManagementLink}/app/sb/requesthistory`
        //       },
        //       {
        //         name: "Access Management",
        //         link: `${this.modelManagementLink}/app/sb/accessmanagement`
        //       }
        //     ]
        //   };
        //   this.menuOption.push(sbObj);
        // }
        if (mexData.is_lab_access_url || mexData.is_sellside) {
          this.menuOption.push({
            name: "Labs",
            link: `/labs`,
            isRouterLink: true,
          });
        }
        if (mexData.is_apitutorial_access_url) {
          this.menuOption.push({
            name: "API Tutorials",
            link: `/apitutorials`,
            isRouterLink: true,
          });
        }
        if (mexData.user_type === "INTERNAL" || mexData.pharma_access) {
          this.menuOption.push({
            name: "BioPharma",
            link: `/biopharma/database`,
            isRouterLink: true,
          });
        }
        if (mexData.show_capiq_link) {
          this.menuOption.push({
            name: "S&P Capital IQ Pro",
            link: mexData.capiq_link,
            showLinkIcon: true,
            linkTarget: "_blank",
          });
        }

        // if (
        //   mexData.user_is_admin &&
        //   mexData.user_is_superuser &&
        //   this.showReportCenter
        // ) {
        //   const rcObj = {
        //     name: "Report Center",
        //     values: [
        //       {
        //         name: "Embargo Management",
        //         link: `/reportcenter/embargomanagement`,
        //         isRouterLink: true
        //       }
        //     ]
        //   };
        //   this.menuOption.push(rcObj);
        // }

        if (this.pageName !== "exceladdin") {
          this.dataService.toastNotification(mexData.user_id, mexData.nHost);
        }

        const globalSettings = {
          // add value from mex response -- if need to add in store
          watcherAccess: mexData.watcheraccess,
          sellsideBrokerShortname: mexData.sell_side_broker_shortname,
          showEntitlementsPage: mexData.show_entitlements_page,
          usersnapJsKey: mexData.usersnap_js_key,
          userDetails: mexData.user_details,
          userName: mexData.display_user_name,
          userId: mexData.user_id,
          notificationHost: mexData.nHost,
          isAdmin: mexData.user_is_admin,
          hasChartsPageAccess: mexData.charts_page_access,
          showDedicatedPage: mexData.research_page_access,
          isConsensusOnlyUser: mexData.is_consensus_only_user,
          firm_name: mexData.firm_name,
          isConsensusPlusUser: mexData.is_conplus_user,
          isInternal: mexData.is_internal,
          isSellside: mexData.is_sellside,
          show_set_passwd: mexData.show_set_passwd,
          events_access: mexData.events_access,
          isModelsOnlyUser: mexData.user_type === "MODELS_ONLY_INBOX",
          show_labs_secondarymenu: mexData.labs_secondary_menu,
          hasMarketDataAccess: mexData.market_data_access,
          hasDsmAccess: mexData.is_dsm_access,
          restrictAccessToTprPage: mexData.hide_tpr,
          showCorporateEntitlements: mexData.show_corporate_entitlements,
          showNavFB: mexData.nav_fb_visible,
          pharmaAccess: {
            hasBiopharmaDrugPageAccess: true, //mexData.biopharma_drug_page_access,
            hasBiopharmaAccess: mexData.pharma_access,
            hasPharmaDSMAccess: mexData.pharma_dsm_access,
          },
        };
        window.hasDsmAccess = globalSettings.hasDsmAccess;
        this.store.dispatch(new SetMenuOption(this.menuOption));
        this.store.dispatch(new SetGlobalSettings(globalSettings));
        this.store.dispatch(
          new SetNotificationSettings({
            notificationHost: mexData.nHost,
            userId: mexData.user_id,
            fetchNewData: true,
          }),
        );
        // Set user details fro RUM session
        if (
          environment.datadogRum &&
          environment.datadogRum.active &&
          mexData.user_details
        ) {
          setRumUserDetails(mexData.user_details.email);
        }

        if (mexData.PROD_ANALYTICS_FLAG) {
          TrackJS.install({
            token: "9ba67589022a49f494cb876471c1f349",
            application: "insights-trackjs-key",
          });
        }
        //Pendo code
        // Executing pendo initialization is next cycle so that we get current this.pageName
        setTimeout(() => {
          if (this.pageName !== "exceladdin")
            window.pendo.initialize({
              visitor: {
                id: mexData.user_id, // Required if user is logged in
                email: mexData.user_details.email,
                first_name: mexData.user_details.first_name,
                last_name: mexData.user_details.last_name,
              },

              account: {
                id: mexData.firm_name,
                user_type: mexData.userType,

                // You can add any additional account level key-values here,
                // as long as it's not one of the above reserved names.
              },
            });
        }, 0);
        //end pendo code
      },
      (error) => {
        console.error(error);
      },
    );
  }
}
